/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Session_EmptyInputs */

const en_us2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout has no exercises yet.`)
};

const pt_br2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda não tem exercícios.`)
};

const es_419_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento todavía no tiene ejercicios.`)
};

const pt_pt2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda não tem exercícios.`)
};

const fr_fr2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance n'a pas encore d'exercices.`)
};

const de_de2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training hat noch keine Übungen.`)
};

const it_it2_plan_session_empty = /** @type {(inputs: Plan_Session_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento non ha ancora esercizi.`)
};

/**
* | output |
* | --- |
* | "This workout has no exercises yet." |
*
* @param {Plan_Session_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_empty = /** @type {((inputs?: Plan_Session_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_empty(inputs)
	if (locale === "es-419") return es_419_plan_session_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_empty(inputs)
	if (locale === "de-DE") return de_de2_plan_session_empty(inputs)
	if (locale === "it-IT") return it_it2_plan_session_empty(inputs)
	return en_us2_plan_session_empty(inputs)
});
export { plan_session_empty as "plan.session_empty" }